import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyMixin } from '../../theme/Typography/Typography.utils';
export var Headline = forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? '300' : _b, _c = _a.component, component = _c === void 0 ? 'div' : _c, withMarginBottom = _a.withMarginBottom, restProps = __rest(_a, ["variant", "component", "withMarginBottom"]);
    return (React.createElement(SHeadline, __assign({ ref: ref, as: component, "$variant": variant, "$withMarginBottom": withMarginBottom }, restProps)));
});
var SHeadline = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  ", ";\n  ", ";\n"], ["\n  margin: 0;\n  ", ";\n  ",
    ";\n"])), function (_a) {
    var $variant = _a.$variant;
    return css(typographyMixin('headline', $variant));
}, function (_a) {
    var $withMarginBottom = _a.$withMarginBottom;
    return $withMarginBottom && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: 0.35em;\n    "], ["\n      margin-bottom: 0.35em;\n    "])));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Headline.js.map